import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex)
Vue.config.devtools = true;

export default new Vuex.Store({
  state: {
    currentScreen: "0",
    numTournaments: 0,
    matchType: "live",
    tournamentId: "0",
    matchId: "0",
    tennisData: {},
    selectedMatchData: {},
    completedMatchesData: [],
    liveMatchesData: [],
    matchData: {},
    Match: [],

    matchEndTimes: {},        // Tracks when match changed from live to finished
    matchLastSeen: {},        // Tracks when match was last seen
    matchFinishedStatus: {}   // Tracks last known matchFinished value
  },

  mutations: {
    SET_MATCH_TYPE(state, payload) {
      state.matchType = payload;
    },
    SET_TOURNAMENT_ID(state, payload) {
      state.tournamentId = payload;
    },
    SET_NUMBER_TOURNAMENTS(state, payload) {
      state.numTournaments = payload;
    },
    SET_MATCH_ID(state, payload) {
      state.matchId = payload;
    },
    SET_CURRENT_SCREEN(state, payload) {
      state.currentScreen = payload;
    },

    SET_TENNIS_DATA(state, payload) {
      const now = new Date();

      const updateMatch = (match) => {
        const id = match.matchID;

        // Track previous status
        const prevStatus = state.matchFinishedStatus?.[id];
        state.matchFinishedStatus = state.matchFinishedStatus || {};
        state.matchFinishedStatus[id] = match.matchFinished;

        const transitionedToFinished = prevStatus === "False" && match.matchFinished === "True";

        if (transitionedToFinished) {
          if (!state.matchEndTimes[id]) {
            state.matchEndTimes[id] = now.toISOString();
          }
          match.matchEndTime = state.matchEndTimes[id];
        } else if (match.matchFinished === "True" && state.matchEndTimes[id]) {
          // Reuse stored end time if already set
          match.matchEndTime = state.matchEndTimes[id];
        }

        // Track last seen time
        state.matchLastSeen[id] = now.toISOString();
      };

      if (state.numTournaments > 1) {
        for (const tournamentId in payload) {
          payload[tournamentId].AETennis.Match.forEach(updateMatch);
        }
      } else {
        payload.AETennis.Match.forEach(updateMatch);
      }

      state.tennisData = payload;
    },

    SET_MATCH_DATA(state, payload) {
      state.selectedMatchData = payload;
    },

    SET_NOT_LOADED_IDS(state, payload) {
      state.notLoadedIds = payload;
    }
  },

  actions: {
    setMatchType({ commit }, payload) {
      commit("SET_MATCH_TYPE", payload);
    },
    setTournamentId({ commit }, payload) {
      commit("SET_TOURNAMENT_ID", payload);
    },
    setNumTournaments({ commit }, payload) {
      commit("SET_NUMBER_TOURNAMENTS", payload);
    },
    setMatchId({ commit }, payload) {
      commit("SET_MATCH_ID", payload);
    },
    setCurrentScreen({ commit }, payload) {
      commit("SET_CURRENT_SCREEN", payload);
    },
    setTennisData({ commit }, payload) {
      commit("SET_TENNIS_DATA", payload);
    },
    setMatchData({ commit }, payload) {
      commit("SET_MATCH_DATA", payload);
    },
    setNotLoadedIds({ commit }, payload) {
      commit("SET_NOT_LOADED_IDS", payload);
    },
  },

  getters: {
    matchType: state => state.matchType,
    tournamentId: state => state.tournamentId,
    numTournaments: state => state.numTournaments,
    matchId: state => state.matchId,
    currentScreen: state => state.currentScreen,
    tennisData: state => state.tennisData,
    selectedMatchData: state => state.selectedMatchData,

    getTennisData: (state) => (tournamentId, matchId) => {
      return state.tennisData[tournamentId].AETennis.Match.find(i => i.matchID === matchId);
    },

    matches: state => (tournamentId, matchState) => {
      const now = new Date();
      const oneHourDelayMs = 60 * 60 * 1000; // 1 hour
      const fallbackTimeoutMs = 30 * 1000;   // 30s stale fallback

      const filterMatches = (matches) => {
        return matches.filter(match => {
          const lastSeen = state.matchLastSeen?.[match.matchID];
          const tooOld = lastSeen && (new Date(lastSeen).getTime() + fallbackTimeoutMs < now.getTime());

          if (matchState === "False") {
            return (
              match.matchFinished === "False" ||
              (match.matchFinished === "True" &&
               match.matchEndTime &&
               new Date(match.matchEndTime).getTime() + oneHourDelayMs > now.getTime())
            );
          } else {
            return (
              match.matchFinished === "True" &&
              (
                (!match.matchEndTime || new Date(match.matchEndTime).getTime() + oneHourDelayMs <= now.getTime()) ||
                tooOld
              )
            );
          }
        });
      };

      if (state.numTournaments > 1) {
        return state.tennisData[tournamentId]?.AETennis
          ? filterMatches(state.tennisData[tournamentId].AETennis.Match)
          : [];
      } else if (state.numTournaments === 1) {
        return state.tennisData?.AETennis
          ? filterMatches(state.tennisData.AETennis.Match)
          : [];
      }

      return [];
    }
  }
});